export function title(state) {
  return state.title
}
export function navColor(state) {
  return state.navColor
}
export function navTextColor(state) {
  return state.navTextColor
}
export function showNav(state) {
  return state.showNav
}

export function backTo(state) {
  return state.backTo
}

export function dialogDealer(state) {
  return state.dialogDealer
}

export function typeVehicle(state) {
  return state.typeVehicle
}

export function dialogMainMenu(state) {
  return state.dialogMainMenu
}

export function drawerMenu(state) {
  return state.drawerMenu
}
